/**
 * Created by Ram on 14/09/2016.
 */

import React, { Component } from 'react'

export default class SignUpButton extends Component {
    render() {
        return (
            <button type="button" className="btn btn-default btn-md header-button-styles" onClick={this.props.onClick}>{this.props.displayText}</button>
        )
    }
}
